document.addEventListener('DOMContentLoaded', ()=>{
    if (document?.querySelectorAll('.productInfo__single__media_nt.swiper')?.length) {
        new Swiper('.productInfo__single__media_nt.swiper', {
            slidesPerView: 'auto',
            spaceBetween: 6,
            navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
        });
    }

    if (document?.querySelectorAll('.Swp___rvws__slider.swiper')?.length) {
        new Swiper('.Swp___rvws__slider.swiper', {
            slidesPerView: 1,
            spaceBetween: 2,
            pagination: { el: ".swiper-pagination", clickable: true }
        });
    }    
    const collapsibleTab = (target)=>{
        target.target.closest('[js-collapsible-outer]').classList.toggle('active');
        if ( target.target.closest('[js-collapsible-outer]').classList.contains('active') ){
        let HeightElementData = target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]');
        target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]').style.maxHeight = `${HeightElementData.scrollHeight}px`;
        }else{
        target.target.closest('[js-collapsible-outer]').querySelector('[js-collapsible-content]').style.maxHeight = null;
        }              
    }
    document.querySelectorAll('[js-collapsible-header]').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
        target.preventDefault();
        if( target.target.closest('[js-collapsible-outer]').classList.contains('js-mobile-accoridon') && window.screen.width < 750 && !target.target.closest('[js-collapsible-outer]').classList.contains('js-should-open-one') ){
            collapsibleTab(target);
        }else if( !target.target.closest('[js-collapsible-outer]').classList.contains('js-mobile-accoridon') && target.target.closest('[js-collapsible-outer]').classList.contains('js-should-open-one') ){
            collapsibleTabOpenTime(target);
        }else if( !target.target.closest('[js-collapsible-outer]').classList.contains('js-mobile-accoridon') && !target.target.closest('[js-collapsible-outer]').classList.contains('js-should-open-one') ){
            collapsibleTab(target);
        }
        })
    }); 
    class PurchaseSelectionBubble extends HTMLElement {
        constructor() {
            super();
            this.attachEvents();
        }
        attachEvents() {
            this.querySelectorAll(`.bubbleSwatch__element_interior`).forEach((elm)=>{
                elm.querySelector(`label`).addEventListener('change', () => {
                    this.syncVariants();
                });
            });
            // this.defaultSelected = this.querySelector('.bubbleSwatch__interior').firstChild.querySelector('input');
            // this.defaultSelected.click();
            // this.defaultSelectedClick = new Event('click', { bubbles: true, cancelable: true });
            // this.defaultSelected.dispatchEvent(this.defaultSelectedClick);            
        }
        syncVariants() {
            this.selectedValue();
            this.selectMasterVariant(this.choosedOneTime);
            this.UpdateAppearance();
        }
        selectedValue() {
            this.choosedOneTime = [...this.querySelectorAll('.bubbleSwatch__element_interior input:checked')].map(input => input.value);
        }
        getVariantData() {
            return this.variantData ||= JSON.parse(this.querySelector('[type="application/json"]').textContent);
        }
        selectMasterVariant(choices) {
            this.currentVariant = this.getVariantData().find(variant =>
            !variant.options.some((opt, idx) => opt !== choices[idx])
            );
        }
        renderProductInfo(requestUrl) {
            fetch(requestUrl)
            .then(response => response.text())
            .then(htmlString => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlString, 'text/html');
                const SectionId = doc.querySelector('.mainProduct__layoutwp').dataset.section;
                const sectionPriceEl = doc.querySelector(`[data-widget-price="priceEl-${SectionId}"]`).innerHTML;
                const sectionBadgeEl = doc.querySelector(`[data-badge="badge-El-${SectionId}"]`).innerHTML;
                const sectionButtonEl = doc.querySelector(`[data-button="button-El-${SectionId}"]`).innerHTML;
                document.querySelector(`[data-widget-price="priceEl-${SectionId}"]`).innerHTML = sectionPriceEl;
                document.querySelector(`[data-badge="badge-El-${SectionId}"]`).innerHTML = sectionBadgeEl;
                document.querySelector(`[data-button="button-El-${SectionId}"]`).innerHTML = sectionButtonEl;
            })
            .catch(err => {
                console.error("Drawer fetch error:", err);
            });
        }        
        UpdateAppearance() {
            this.submitBtns = document.querySelectorAll(`.mainProduct__addbutton.product-form__submit[type="submit"]`);
            if (!this.currentVariant) return;
            this.isAvailable = this.currentVariant.available;
            this.soldOut = !this.isAvailable;
            [...this.submitBtns].forEach(btn => {
                this.label = btn.querySelector('span');
                if( this.soldOut == true ){
                   this.label.innerHTML = window.variantStrings.soldOut;
                }else{
                   this.label.innerHTML = window.variantStrings.addToCart;
                }
                btn.disabled = this.soldOut;
            });
            this.closest('.productInfo__singleLayout__ct_interior').querySelector('.productMain__buybuttons_main').querySelector('[name="id"]').value = this.currentVariant.id;
            this.productHandle = document.querySelector('.mainProduct__layoutwp')?.dataset.url;
            if (this.productHandle) {
                window.history.replaceState(null, '', `${this.productHandle}?variant=${this.currentVariant.id}`);
                this.renderProductInfo(`${this.productHandle}?variant=${this.currentVariant.id}`);
            }
        }
    }
    customElements.define('cus-bubble-swatch', PurchaseSelectionBubble);

    function isInViewport(elem) {
        const rect = elem.getBoundingClientRect();
        return (
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    const stickyBar = document.querySelector('.productSingleLayout__stickywp');
    const addToCartElements = document.querySelectorAll('.mainProduct__addbutton');
    const footerSections = document.querySelectorAll('.shopify-section-group-footer-group');
    
    function shouldHideSticky() {
        for (const el of [...addToCartElements, ...footerSections]) {
        if (el && isInViewport(el)) return true;
        }
        return false;
    }
    
    function handleStickyScroll() {
        const scrollY = window.scrollY;
        const triggerElement = document.querySelector('.mainProduct__addbutton');
        if (!triggerElement || !stickyBar) return;
        const triggerOffset = triggerElement.offsetTop;
        if (scrollY > triggerOffset) {
        if (shouldHideSticky()) {
            stickyBar.classList.remove('stickyAddToCart');
            document.body.classList.remove('BottomStick');
        } else {
            stickyBar.classList.add('stickyAddToCart');
            document.body.classList.add('BottomStick');
        }
        } else {
            stickyBar.classList.remove('stickyAddToCart');
            document.body.classList.remove('BottomStick');
        }
    }
    window.addEventListener('scroll', handleStickyScroll, { passive: true });

    document.querySelectorAll('.Layout__sticky_bubbleSwatch__element').forEach((el)=>{
        el.querySelector('.Layout__sticky_bubbleSwatch__label').addEventListener('change', (target)=>{
            document.querySelector(`.bubbleSwatch__input[value="${target.target.defaultValue}"]`).click();
        })
    })

    if( document.querySelectorAll('.Layout__sticky_bubbleSwatch__action').length > 0 ){
        document.querySelector('.Layout__sticky_bubbleSwatch__action').addEventListener('click', (e) => {
            e.preventDefault();
            let allSelectedValueIds = [];
            let idsV = document.querySelector('.productMain__buybuttons_main').querySelector('[name="id"]').value;
            allSelectedValueIds.push({id: idsV,quantity: 1});
            const submitBtnWp = e.target;
            submitBtnWp.classList.add('loading');
            const cartDrawer = document.querySelector('cart-drawer');
            const bundleCart = {
            items: allSelectedValueIds,
            sections: cartDrawer?.getSectionsToRender()?.map(s => s.section) || [],
            sections_url: window.location.pathname
            };
            fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(bundleCart),
            credentials: 'same-origin'
            }).then(res => res.json())
            .then( (data) =>{
                console.log(data);
                cartDrawer?.renderContents(data)
            }) 
            .catch(console.error)
            .finally(() => {
                if (cartDrawer) {
                if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
                cartDrawer.open();
                }
                submitBtnWp.classList.remove('loading');

                fetch('/cart.js', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                    })
                    .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json(); 
                    })
                    .then(cartData => {
                    const priceThreshold = 9000;
                    if (cartData.total_price < priceThreshold) {
                        const itemsToRemove = [];
                        cartData.items.forEach(item => {
                            if (item.properties && item.properties.upsell_offer) {
                                itemsToRemove.push(item.id); 
                            }
                        });
                        if (itemsToRemove.length > 0) {
                            let updates_rmv = {};
                            itemsToRemove.forEach(id => {
                                updates_rmv[id] = 0;
                            });
                            fetch(window.Shopify.routes.root + 'cart/update.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ updates: updates_rmv }) 
                            })
                            .then(response => {
                                if (!response.ok) {
                                    return response.text().then(text => { throw new Error(`Cart update failed: ${response.status} - ${text}`) });
                                }
                                return response.json();
                            })
                            .then((responseText) => {
                                cartDrawer.refreshCartContent();
                            })
                            .catch(error => {
                                console.error("Error during upsell item removal:", error);
                            });
                        }
                    }
                    if( cartData.total_price < 7000 ){
                        const itemsToRemoveRs = [];
                        cartData.items.forEach(item => {
                            if (item.properties && item.properties.upsell_offer_rs) {
                                itemsToRemoveRs.push(item.id); 
                            }
                        });
                        if (itemsToRemoveRs.length > 0) {
                            let updates_rmvrs = {};
                            itemsToRemoveRs.forEach(id => {
                                updates_rmvrs[id] = 0;
                            });
                            fetch(window.Shopify.routes.root + 'cart/update.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ updates: updates_rmvrs }) 
                            })
                            .then(response => {
                                if (!response.ok) {
                                    return response.text().then(text => { throw new Error(`Cart update failed: ${response.status} - ${text}`) });
                                }
                                return response.json();
                            })
                            .then((responseText) => {
                                cartDrawer.refreshCartContent();
                            })
                            .catch(error => {
                                console.error("Error during upsell item removal:", error);
                            });
                        }
                    }
                    // if( cartData.total_price >= 7000 ){
                    //     const itemsToRemoveRschk = [];
                    //     cartData.items.forEach(item => {
                    //         if (item.properties && item.properties.upsell_offer_rs) {
                    //             itemsToRemoveRschk.push(item.id); 
                    //         }
                    //     });
                    //     if (itemsToRemoveRschk.length == 0) {
                    //         let u_idrs = 55238358499701;
                    //         let u_updateProductrs = {'items': [{'id': u_idrs,'quantity': 1,'properties': {'upsell_offer_rs': 'true'} }]};              
                    //         fetch(window.Shopify.routes.root + 'cart/add.js', {
                    //             method: 'POST',
                    //             headers: {'Content-Type': 'application/json'},
                    //             body: JSON.stringify(u_updateProductrs)
                    //         }).then((response) => response.text())
                    //         .then((responseText) => {
                    //             cartDrawer.refreshCartContent();
                    //         }).finally(() =>{  }).catch((e) => { console.error(e); });          
                    //     }
                    // }
                })

            })

        });
    }


// video popup 


// Open video popup
document.addEventListener('click', function (e) {
    const target = e.target.closest('[videtag]');
    if (target) {
      e.preventDefault();
  
      const VideoTag = target.getAttribute('videtag');
  
      document.body.classList.add('videoActive');
  
      document.body.insertAdjacentHTML('beforeend', `
        <div class="WrapperPopupWithThumbnail">
          <div class="Container__Wp_thumbnail">
            <div class="CrossPopupThumb">
           ×
            </div>
            <div class="container__Video_init">
                <video playsinline autoplay controls>
                  <source src="${VideoTag}" type="video/mp4">
                </video>
            </div>
          </div>
        </div>
      `);
    }
  });
  
  // Close when clicking the cross button
  document.addEventListener('click', function (e) {
    if (e.target.closest('.CrossPopupThumb')) {
      e.preventDefault();
      const popup = document.querySelector('.WrapperPopupWithThumbnail');
      if (popup) popup.remove();
      document.body.classList.remove('videoActive');
    }
  });
  
  // Click outside to close
  document.addEventListener('click', function (e) {
    const isInside = e.target.closest('.video_wrapper, .Container__Wp_thumbnail');
    if (!isInside) {
      const popup = document.querySelector('.WrapperPopupWithThumbnail');
      if (popup) popup.remove();
      document.body.classList.remove('videoActive');
    }
  });

  
})